var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGetCreditIcon = function SvgGetCreditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 34 38"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "get-credit-icon_svg__b",
    x1: "32.998%",
    y1: "-10.088%",
    y2: "83.136%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F4F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F8F8F9"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "get-credit-icon_svg__a",
    cx: 15,
    cy: 18,
    r: 15
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.345,
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#60BC57",
    xlinkHref: "#get-credit-icon_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#get-credit-icon_svg__b)",
    xlinkHref: "#get-credit-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#60BC57",
    stroke: "#60BC57",
    d: "M13.5 12a.5.5 0 0 0-.5.5v1.031c-.74.078-1.418.324-1.94.75a2.835 2.835 0 0 0-1.033 2.219c0 .985.52 1.678 1.173 2.078.653.4 1.414.597 2.112.875 1.144.417 2.66.878 2.675 2.047 0 .613-.257 1.07-.688 1.422-.43.35-1.056.578-1.8.578-1.214 0-2.155-.75-2.565-1.438-.11-.264-.46-.384-.704-.234-.243.15-.308.53-.125.75a3.986 3.986 0 0 0 2.91 1.875c0 .017-.016.03-.016.047v1a.5.5 0 0 0 1.002 0v-1.031c.74-.081 1.417-.34 1.94-.766a2.803 2.803 0 0 0 1.032-2.203c0-.985-.52-1.694-1.173-2.094-.653-.4-1.414-.597-2.112-.875-1.137-.416-2.66-.876-2.675-2.03 0-.614.257-1.087.688-1.438.43-.351 1.056-.563 1.8-.563 1.214 0 2.155.735 2.565 1.422.11.264.46.384.704.234.243-.15.308-.53.125-.75a3.963 3.963 0 0 0-2.91-1.859c0-.017.016-.03.016-.047v-1a.5.5 0 0 0-.501-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 17v4m-2-2h4",
    stroke: "#60BC57",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#60BC57",
    strokeLinecap: "round",
    d: "M14.84 37C24.87 37 33 28.941 33 19S24.87 1 14.84 1c-2.462 0-4.81.486-6.95 1.366A18.197 18.197 0 0 0 2 6.272m4.102.017-4.436.138L.668 2"
  }))));
};
export default SvgGetCreditIcon;